export class PtvsDummyData {

    private static PtvsDymmyList: PtvDummyItem[] = [
        {Ptv:"GOOGLE_REVIEW_URL", DummyData:"https://frc.ac/xxxxx"}
    ];

    static ReplaceToDummyData(input:string):string{
        
        PtvsDummyData.PtvsDymmyList.forEach(x=>{
            var re = new RegExp('{{' + x.Ptv + '}}', 'g');
            input = input.replace(re, x.DummyData);
        })
        return input
    }

    static ReplaceFromDummyData(input:string):string{
        
        PtvsDummyData.PtvsDymmyList.forEach(x=>{
            var re = new RegExp(x.DummyData, 'g');
            input = input.replace(re, '{{' + x.Ptv + '}}' );
        })
        return input
    }


}

export class PtvDummyItem{
    Ptv: string;
    DummyData: string;
}
